import gql from "graphql-tag";

export const MY_LEAVE_CREATE_REQUEST = gql`
  mutation createLeaveRequest(
    $contract: String!
    $startDate: Date!
    $endDate: Date!
    $workDays: Int!
    $effectiveWorkDays: Float!
    $type: String!
    $message: String
    $locale: String!
    $isAssigner: Boolean
  ) {
    createLeaveRequest(
      contract: $contract
      startDate: $startDate
      endDate: $endDate
      workDays: $workDays
      effectiveWorkDays: $effectiveWorkDays
      type: $type
      message: $message
      locale: $locale
      isAssigner: $isAssigner
    ) {
      createdAt
    }
  }
`;
